var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/finally';
import humps from 'humps';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, publish } from 'rxjs/operators';
import { map } from 'rxjs/operators/map';
import { EnvironmentProvider } from '../../providers/environment/environment';
/**
 * Wrapper class for http requests made to the Yoshi server. This class is not intended to be called directly by any component,
 * instead one of the available service providers should be used (e.g UserProvider).
 */
let ApiProvider = ApiProvider_1 = class ApiProvider {
    constructor(http, environment) {
        this.http = http;
        this.environment = environment;
        this.etagsMap = {};
    }
    call(options) {
        if (!this.isAuthorized(options)) {
            return Observable.throw(ApiProvider_1.UNAUTHORIZED_ERROR);
        }
        this.sanitizeOptions(options);
        this.setHeaders(options);
        options.observe = options.includePageInfo ? 'response' : 'body';
        const response = this.http
            .request(options.method, options.url, options)
            .pipe(catchError(this.parseError), map((res) => {
            if (options.observe === 'response') {
                let apiCallResponse = {
                    response: res.body,
                    status: res.status,
                };
                if (options.includePageInfo) {
                    apiCallResponse['pageInfo'] = JSON.parse(res.headers.get('x-pagination'));
                }
                if (options.compareEtag) {
                    apiCallResponse['etag'] = res.headers.get('etag');
                    const url = options.url +
                        (options.params ? 'page=' + options.params.page || '' : '');
                    this.etagsMap[url] = res.headers.get('etag');
                }
                return apiCallResponse;
            }
            else if (options.observe === 'body') {
                return res;
            }
        }), publish());
        response.connect();
        return response;
    }
    isAuthorized(options) {
        const loggedIn = this.authData && this.authData.user_uid;
        return !options.url.includes(ApiProvider_1.USER_UID) || loggedIn;
    }
    sanitizeOptions(options) {
        options.method = options.method || 'GET';
        options.body = options.body
            ? humps.decamelizeKeys(options.body, { separator: '_' })
            : {};
        options.body = options.convertToParams
            ? this.convertToParams(options.body)
            : options.body;
        options.params = options.params
            ? humps.decamelizeKeys(options.params, { separator: '_' })
            : {};
        if (this.authData) {
            options.url = options.url.replace(ApiProvider_1.USER_UID, this.authData.user_uid);
            options.params.auth_key = this.authData.auth_key;
        }
        let baseURL = options.ops
            ? this.environment.serverVars().opsEndpoint
            : this.environment.serverVars().apiEndpoint;
        options.url = baseURL + options.url;
        return options;
    }
    setHeaders(options) {
        let headers = new HttpHeaders();
        if (!(options.body instanceof FormData)) {
            headers.append('Content-Type', 'application/x-www-form-urlencoded');
        }
        const url = options.url + (options.params ? 'page=' + options.params.page || '' : '');
        if (options.compareEtag && this.etagsMap[url]) {
            headers = headers.append('If-None-Match', this.etagsMap[url]);
        }
        options.headers = headers;
        return options;
    }
    // Necessary when request body includes an array of strings
    // TODO: Find a cleaner way to do this on client or server
    convertToParams(body = {}) {
        let params = new HttpParams();
        for (let key in body) {
            if (body[key] instanceof Array) {
                const list = body[key];
                for (let item of list) {
                    params = params.append(`${key}[]`, item);
                }
            }
            else {
                params = params.set(key, body[key]);
            }
        }
        return params;
    }
    parseError(error) {
        if (error && error.status == '304') {
            // 304 is technically not an error, however, angular treats it as one.
            return Observable.throw({ status: 304, statusText: 'not-modified' });
        }
        let errorMessage = '';
        console.log('handle error', error);
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        }
        else {
            // server-side error
            const errorResponse = error && error.error;
            const errorArray = errorResponse && errorResponse.errors;
            const firstError = errorArray && errorArray.length && errorArray[0];
            if (firstError && firstError.param && firstError.message) {
                errorMessage = `Invalid ${firstError.param.replace('_', ' ')} - ${firstError.message}`;
            }
            else if (firstError && firstError.message) {
                errorMessage = firstError.message;
            }
            else if (errorResponse && errorResponse.message) {
                errorMessage = errorResponse.message;
            }
            else if (error) {
                errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
            }
            else {
                errorMessage = 'Unknown Error';
            }
        }
        return Observable.throw(errorMessage);
    }
};
ApiProvider.USER_UID = 'CURRENT_USER_UID';
ApiProvider.UNAUTHORIZED_ERROR = new Error('Not logged in');
ApiProvider = ApiProvider_1 = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [HttpClient,
        EnvironmentProvider])
], ApiProvider);
export { ApiProvider };
let EmptySubscriber = class EmptySubscriber {
    constructor() {
        this.next = () => { };
        this.error = () => { };
        this.complete = () => { };
    }
};
EmptySubscriber = __decorate([
    Injectable()
], EmptySubscriber);
export { EmptySubscriber };
var ApiProvider_1;
//# sourceMappingURL=api.js.map


// WEBPACK FOOTER //
// ./src/providers/api/api.ts.pre-build-optimizer.js